<template>
  <v-container>
    <v-layout row wrap my-5 pb-3>
      <v-flex xs12>
        <h3>
          <v-icon large color="yellow">mood_bad</v-icon>
          Stress Order
        </h3>
      </v-flex>
      <v-flex xs9><stress-order-form class="pa-5"></stress-order-form></v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import StressOrderForm from "@/components/StressOrderForm";

export default {
  components: {
    StressOrderForm
  }
};
</script>
